export const DOMAIN_NAME = (() => {
  if (process.env.GUILD_ENV === 'staging') {
    return 'staging.guild.host'
  }

  if (process.env.GUILD_ENV === 'production') {
    return 'guild.host'
  }

  return 'localhost:5173'
})()

export const HOST_NAME = (() => {
  if (process.env.NODE_ENV === 'production') {
    return `https://${DOMAIN_NAME}`
  }

  return `http://${DOMAIN_NAME}`
})()

export const INBOX_DOMAIN = (() => {
  if (process.env.GUILD_ENV === 'staging') {
    return 'staging-inbox.guild.host'
  }

  if (process.env.GUILD_ENV === 'production') {
    return 'inbox.guild.host'
  }

  return 'inbox.guild.host'
})()

// Cloudflare Worker image URL for user-uploaded images
// Example usage:
//   User photo: `${IMAGES_URL}/i/r/${imageId}.${ext}?w=100&h=100&dpr=3&fo=auto`
//   Static asset: `${IMAGES_URL}/i/static/icons/calendar.png?w=32&h=32&dpr=3`
export const IMAGES_URL = HOST_NAME

// Static asset URL helper - for icons, backgrounds, logos stored in R2
// Usage: `${STATIC_IMAGES_URL}/icons/calendar.png?w=32&h=32&dpr=3`
export const STATIC_IMAGES_URL = `${HOST_NAME}/i/static`
